module.exports = __webpack_public_path__ + "img/1479978818.9f73f912.jpg";